<template>
  <div>
    <Topbar title="Nos offres" backButton />
    <section class="Section" v-if="isLoading || currentWeekOffers.length > 0">
      <div class="Section__header">
        <h2 class="Section__title">Offres de la semaine</h2>
      </div>
      <div class="ProductList">
        <router-link :to="{ name: 'Product', params: { id: offer.id }}" v-for="offer in currentWeekOffers" :key="offer.id">
          <ProductCard v-bind="offer" />
        </router-link>
      </div>
    </section>
    <section class="Section" v-if="isLoading || lastDaysOffers.length > 0">
      <div class="Section__header">
        <h2 class="Section__title">Derniers jours</h2>
      </div>
      <div class="ProductList">
        <router-link
          v-for="offer in lastDaysOffers"
          :to="{ name: 'Product', params: { id: offer.id }}"
          :key="offer.id"
        >
          <ProductCard v-bind="offer" />
        </router-link>
      </div>
    </section>
    <template v-if="isLoading || otherOffers.length > 0">
      <section v-for="(offers, date) in otherOffersByDay" :key="date" class="Section">
        <div class="Section__header">
          <h2 class="Section__title">Offres du {{ date }}</h2>
        </div>
        <div class="ProductList">
          <router-link
            v-for="offer in offers"
            :to="{ name: 'Product', params: { id: offer.id }}"
            :key="offer.id"
          >
            <ProductCard v-bind="offer" />
          </router-link>
        </div>
      </section>
    </template>
    <section class="Section" v-if="isLoading || obsoleteOffers.length > 0">
      <div class="Section__header">
        <h2 class="Section__title">Offres terminées</h2>
      </div>
      <div class="ProductList">
        <router-link
          v-for="offer in obsoleteOffers"
          :to="{ name: 'Product', params: { id: offer.id }}"
          :key="offer.id"
        >
          <ProductCard v-bind="offer" />
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>

import productService from "../services/product";
import ProductCard from "../components/ProductCard";
import dateFormat from "../utils/dateFormat";

export default {
  name: "Offers",
  data() {
    return {
      products: [],
      isLoading: true
    };
  },
  computed: {
    currentWeekOffers() {
      const currentWeekInterval = 7 * 24 * 60 * 60 * 1000; // 7 days

      return this.products
        .filter(product => this.currentOffers.includes(product))
        .filter(({ offer }) => new Date(offer.publication_date).getTime() > (Date.now() - currentWeekInterval));
    },
    currentOffers() {
      return this.products
        .filter(product => !this.obsoleteOffers.includes(product))
        .filter(({ offer }) => new Date(offer.publication_date).getTime() < Date.now());
    },
    obsoleteOffers() {
      return this.products.filter(({ offer }) => new Date(offer.expiration_date).getTime() < Date.now());
    },
    lastDaysOffers() {
      const lastDaysInterval = 2 * 24 * 60 * 60 * 1000; // 2 days

      return this.products
        .filter(product => this.currentOffers.includes(product))
        .filter(product => !this.currentWeekOffers.includes(product))
        .filter(({ offer }) => new Date(offer.expiration_date).getTime() - lastDaysInterval < Date.now());
    },
    otherOffers() {
      return this.products.filter(
        product => this.currentOffers.includes(product)
          && !this.currentWeekOffers.includes(product)
          && !this.lastDaysOffers.includes(product)
      );
    },
    otherOffersByDay() {
      const offers = this.otherOffers
        .reduce((acc, product) => {
          const publicationDate = product.offer.publication_date;

          if (!(publicationDate in acc)) {
            acc[publicationDate] = [product];
          } else {
            acc[publicationDate].push(product);
          }

          return acc;
        }, {}
        );

      // sort keys by date
      return Object.keys(offers)
        .sort((a, b) => new Date(b).getTime() - new Date(a).getTime())
        .reduce((acc, date) => {
          acc[dateFormat(date)] = offers[date];

          return acc;
        }, {});
    }
  },

  created() {
    productService.getOffers({ sort: "promo_price_asc" })
      .then(({ data: products }) => {
        this.products = products.filter(product => typeof product.offer !== "undefined");
        this.isLoading = false;
      });
  },
  components: { ProductCard }
};
</script>
